/** @jsxImportSource @emotion/react */
import { Alert, TextField } from "@mui/material";
import { ResponseParamBase } from "../../common/Types";
import { Control, UseFormRegister, FieldError, UseFormWatch, UseFormSetValue } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { BaseSyntheticEvent, useCallback, useEffect, useRef, useState } from "react";
import { UploadFile } from "../../common/Util";
import { ApiUrl } from "../../common/Params";
import Snackbar from '@mui/material/Snackbar';
import { useDropzone } from "react-dropzone";
import configcss from "../../css/config.module.css";
import { IFormInputs } from "../Config";
import { watch } from "fs";

export const UploadImageType = {
    headerImage: "headerIcon",
    chatAdminIcon: "chatAdminIcon",
    chatGuestIcon: "chatGuestIcon",
    sendButtonIcon: "sendButtonIcon",
} as const
export type UploadImageType = typeof UploadImageType[keyof typeof UploadImageType]

type UploadImageProp = {
    headerImage: Blob | MediaSource,
    imageType: UploadImageType,
    onChangeImage: (image: Blob, imageType: UploadImageType) => void,
    control: Control<IFormInputs>,
    register: UseFormRegister<IFormInputs>,
    error: FieldError | undefined,
    watch: UseFormWatch<IFormInputs>,
    setValue: UseFormSetValue<IFormInputs>,
}

type ResponseParam = ResponseParamBase & {

}

const schema = Yup.object({
    uploadFile: Yup.mixed<FileList | null>().test('required', 'ファイルが指定されていません', value => {
        return true
    })
}).required();

export const UploadImage = (prop: UploadImageProp) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [headerImage, setHeaderImage] = useState<Blob | MediaSource>(prop.headerImage);
    //const [imageUrl, setImageUrl] = useState<string>(URL.createObjectURL(prop.headerImage));
    const imgRef = useRef<HTMLImageElement>(null);

    const onDrop = useCallback((files: File[]) => {
        // 指定外のファイルがあれば、何も処理をしない
        if (isDragReject) {
            return;
        }
        //if(!files){
            const dt: DataTransfer = new DataTransfer();
            dt.items.add(files[0]);
            prop.setValue(prop.imageType, dt.files);
        //}
    }, [])
    const {getRootProps, isDragReject, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg'],
        }
    })

    /*const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            uploadFile: null,
            imageType: prop.imageType,
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange"
    });*/

    /*const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        await UploadFile<Blob>(
            ApiUrl.UploadHeaderImage,
            data,
            setIsLoading,
            "blob"
        ).then(response => {
            if (imgRef.current?.src) {
                URL.revokeObjectURL(imgRef.current?.src);
            }
            //setImageUrl((value) => {return URL.createObjectURL(response.data)});
            setHeaderImage((value) => { return response.data });
            prop.onChangeImage(response.data, prop.imageType);
            setOpen(true);
        });
    }*/

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    function imageHeaderTitle(type: UploadImageType): string {
        switch (type) {
            case UploadImageType.headerImage:
                return "ヘッダー画像";
            case UploadImageType.chatAdminIcon:
                return "チャット管理者アイコン";
            case UploadImageType.chatGuestIcon:
                return "チャット利用者アイコン";
            default:
                return "チャット管理者アイコン";
        }
    }

    useEffect(() => {
    }, [])

    return (
        <>
            <div {...getRootProps()} className={configcss['infoBox']}>
                <div className={`${configcss['infoBoxInner']} ${configcss['mdlBox']} ${configcss['infoBoxFlex']}`} style={{backgroundColor: isDragActive ? "gray" : "#efefef"}}>
                    <img src={URL.createObjectURL(prop.watch(prop.imageType)?.[0] ?? new Blob)} ref={imgRef} className={configcss['uploadIcon']}></img>
                    <div className={`${configcss['infoBoxInner-sub']} ${configcss['layoutBox']}`}>
                        <div className={configcss['infoBoxFile']}>    
                            <input {...getInputProps()}/>
                            ファイルを選択またはドラッグアンドドロップ
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    画像を更新しました。
                </Alert>
            </Snackbar>
        </>
    );
}